import { styled } from "simplydo/react/styled";
import { Image } from "simplydo/react/ui/image";

export const FeedItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const FeedItemIcon = styled(Image)`
  width: 30px;
  min-width: 30px;
  height: 30px;
  border-radius: 50%;
  object-fit: cover;
  background-color: ${({ theme }) => theme.primaryColour} !important;
  flex-shrink: 0;
`;

export const FeedItemIconCircle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.primary.soft};
  flex-shrink: 0;
`;

export const FeedItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FeedItemMessage = styled.div`
  line-height: 1.3em;
  color: #999;

  .chip {
    color: #000 !important;
    font-size: 0.95em;
  }
`;

export const FeedItemDate = styled.div`
  font-size: 0.85em;
  color: #999;
`;

export const FeedItemActions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
`;
